<template>
  <div class="container">
    <!-- 全局加载动画 -->
    <div v-if="globalLoading" class="global-loading-overlay">
      <a-spin size="large" :tip="loadingTip">
        <!-- <div class="loading-content">
          <div v-if="allocationProgress.length > 0" class="allocation-progress-list">
            <div v-for="(progress, index) in allocationProgress" :key="index" :class="['progress-item', progress.success ? 'success' : 'error']">
              <a-icon :type="progress.success ? 'check-circle' : 'close-circle'" :style="{ marginRight: '5px' }" />
              {{ progress.message }}
            </div>
          </div>
        </div> -->
      </a-spin>
    </div>
    <div class="card" v-if="!isSharedMode">
      <div class="card-header">
        <span>选择代理商</span>
      </div>
      <div class="agent-search-section">
        <a-input placeholder="已选择代理商" class="agent-search-input" :value="getSelectedAgentsText()" disabled />
        <a-button type="primary" style="margin-left: 10px" @click="showAgentModal">选择代理商</a-button>
      </div>

      <div class="selected-agents-container" v-if="selectedAgents.length > 0">
        <div class="selected-agents-grid">
          <div class="selected-agent-simple" v-for="(agent, index) in selectedAgents" :key="agent.tenantId">
            <div class="selected-agent-text">
              <span class="agent-name">{{ agent.name }}</span>
              <span class="agent-id">ID: {{ agent.tenantId }}</span>
            </div>
            <a-button type="link" size="small" @click="removeSelectedAgent(index)" class="clear-btn">
              <a-icon type="close" />
            </a-button>
          </div>
        </div>
        <div class="clear-all-section" v-if="selectedAgents.length > 1">
          <a-button type="link" size="small" @click="clearAllAgents" class="clear-all-btn">
            <a-icon type="delete" /> 清空所有
          </a-button>
        </div>
      </div>
    </div>

    <div class="card" v-if="isSharedMode">
      <div class="card-header">
        <span>目标代理商</span>
      </div>
      <div class="shared-agent-info">
        <div class="shared-agent-detail">
          <div class="shared-agent-name">{{ sharedAgentName }}</div>
          <div class="shared-agent-id">租户ID: {{ selectedAgentId }}</div>
        </div>
      </div>
    </div>

    <div class="card">
      <div class="traffic-section">
        <div class="card-header">容量分配情况</div>
        <div class="traffic-info">
          <div class="traffic-card">
            <div class="traffic-label">企业总容量</div>
            <div class="traffic-value">
              {{ $formatCapacity(storageData.totalATotalCapacity) }}
            </div>
          </div>
          <div class="traffic-card">
            <div class="traffic-label">已使用</div>
            <div class="traffic-value">
              {{ $formatCapacity(storageData.totalUsedCapacity) }}
            </div>
          </div>
          <div class="traffic-card traffic-card-remaining">
            <div class="traffic-label">剩余可分配容量</div>
            <div class="traffic-value">
              {{ $formatCapacity(storageData.totalResultRemainingCapacity) }}
            </div>
          </div>
        </div>
        <div class="progress-info">
          <span>容量使用进度</span>
          <!-- <span>{{ usagePercentage }}% 已使用</span> -->
        </div>
        <a-progress :percent="usagePercentage" :stroke-width="8" style="width: 92%;" stroke-color="#1890ff" />

        <div class="traffic-allocation">
          <div class="card-header">分配容量</div>
          <div class="allocation-input-section">
            <a-input
              placeholder="请输入分配容量"
              class="allocation-input"
              v-model="allocationAmount"
              type="number"
              :max="getMaxAllocation()"
              :min="getMinAllocation()"
            />
            <span class="allocation-unit">GB</span>
            <a-button
              type="primary"
              @click="confirmAllocation"
              :disabled="
                !allocationAmount ||
                  getAllocationAmountMB() < 10240 ||
                  getTotalAllocationNeeded() > getRemainingCapacity() ||
                  !canAllocate ||
                  (selectedAgents.length === 0 && !selectedAgentId)
              "
              :loading="allocationLoading"
            >
              确认分配
            </a-button>
            <a-button style="margin-left: 10px" @click="cancelAllocation">取消</a-button>
          </div>
        </div>
        <div class="max-allocation">最大可分配: {{ $formatCapacity(getRemainingCapacity()) }} (最小分配10GB)</div>
        <div v-if="!canAllocate" class="allocation-warning">
          <a-icon type="exclamation-circle" style="color: #faad14; margin-right: 5px" />
          剩余可分配容量不足10GB，无法进行分配
        </div>
        <div v-if="!isSharedMode && selectedAgents.length === 0 && !selectedAgentId" class="allocation-warning">
          <a-icon type="exclamation-circle" style="color: #faad14; margin-right: 5px" />
          请先选择代理商
        </div>
        <div v-if="getInsufficientCapacityWarning()" class="allocation-error">
          <a-icon type="exclamation-circle" style="color: #ff4d4f; margin-right: 5px" />
          {{ getInsufficientCapacityWarning() }}
        </div>
      </div>
    </div>

    <div class="card">
      <div class="card-header">最近分配记录</div>
      <a-table
        :columns="recordColumns"
        :dataSource="records"
        :pagination="pagination"
        rowKey="id"
        :loading="recordsLoading"
        style="width: 100%"
        @change="handleTableChange"
      >
        <span slot="createTime" slot-scope="text">
          {{ formatDate(text) }}
        </span>
        <span slot="capacity" slot-scope="text, record">
          {{ $formatCapacity(record.allocateCapacity) }}
        </span>
        <span slot="usedCapacity" slot-scope="text, record">
          {{ $formatCapacity(record.usedCapacity) }}
        </span>
        <span slot="remainingCapacity" slot-scope="text, record">
          {{ $formatCapacity(record.remainingCapacity) }}
        </span>
        <span slot="expireTime" slot-scope="text">
          {{ formatDate(text) }}
        </span>
        <span slot="status" slot-scope="text">
          <span :class="getStatusClass(text)">{{ getStatusText(text) }}</span>
        </span>
      </a-table>
    </div>

    <a-modal
      v-if="!isSharedMode"
      title="选择代理商"
      :visible="agentModalVisible"
      width="1200px"
      @cancel="closeAgentModal"
      @ok="confirmAgentSelection"
      :maskClosable="false"
      okText="确定"
      cancelText="取消"
    >
      <div class="modal-content">
        <a-tabs v-model="activeTab" @change="handleTabChange">
          <a-tab-pane key="1" tab="代理商"></a-tab-pane>
          <a-tab-pane key="2" tab="分销商"></a-tab-pane>
        </a-tabs>

        <div class="table-page-search-wrapper">
          <a-form layout="inline" labelAlign="right">
            <a-row :gutter="48">
              <a-col :md="6" :sm="24">
                <a-form-item label="单位名称">
                  <a-input v-model="agentQueryParam.name" placeholder="请输入" allow-clear />
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item label="联系人">
                  <a-input v-model="agentQueryParam.contacts" placeholder="请输入" allow-clear />
                </a-form-item>
              </a-col>

              <a-col :md="6" :sm="24">
                <a-form-item label="联系人电话">
                  <a-input v-model="agentQueryParam.mobile" placeholder="请输入" allow-clear />
                </a-form-item>
              </a-col>

              <a-col :md="6" :sm="24">
                <span class="table-page-search-submitButtons" style="float: right">
                  <a-button type="primary" @click="handleAgentQuery"><a-icon type="search" />查询</a-button>
                  <a-button style="margin-left: 8px" @click="resetAgentQuery"><a-icon type="redo" />重置</a-button>
                </span>
              </a-col>
            </a-row>
          </a-form>
        </div>

        <a-table
          ref="agentTable"
          :columns="agentColumns"
          :dataSource="agents"
          :pagination="agentPagination"
          rowKey="tenantId"
          :loading="agentsLoading"
          @change="handleAgentTableChange"
          :scroll="{ x: 1500 }"
          :rowClassName="getRowClassName"
          :rowSelection="rowSelection"
        >
          <span slot="name" slot-scope="text, record">
            <a-tooltip placement="topLeft" :title="record.name">
              <span class="tenant-name">{{ record.name || '--' }}</span>
            </a-tooltip>
          </span>
          <span slot="contactInfo" slot-scope="text, record">
            <div>{{ record.contacts || '--' }}</div>
            <div>{{ record.mobile || '--' }}</div>

          </span>
          <span slot="capacityUsage" slot-scope="text, record">
            <div class="capacity-container">
              <div class="capacity-progress">
                <div
                  class="progress-bar"
                  :style="{ width: getUsageRate(record) + '%', backgroundColor: getProgressColor(record) }"
                ></div>
              </div>
              <div class="capacity-text">
                {{ $formatCapacity(record.usedCapacity) }}/{{ $formatCapacity(record.totalCapacity) }}
              </div>
            </div>
          </span>
          <span slot="sharedCapacityUsage" slot-scope="text, record">
            <div class="capacity-container">
              <div class="capacity-progress">
                <div
                  class="progress-bar"
                  :style="{ width: getSharedUsageRate(record) + '%', backgroundColor: getSharedProgressColor(record) }"
                ></div>
              </div>
              <div class="capacity-text">
                {{ $formatCapacity(record.sumUsedCapacity) }}/{{ $formatCapacity(record.sumAllocateCapacity) }}
              </div>
            </div>
          </span>
          <span slot="effectiveTime" slot-scope="text, record">
            <div>生效：{{ record.effectiveTime || '--' }}</div>
            <div>失效：{{ record.expireTime || '--' }}</div>
          </span>
          <span slot="remainingCapacity" slot-scope="text, record">
            <div>{{ $formatCapacity(record.remainingCapacity) }}</div>
          </span>
          <span slot="renewType" slot-scope="text, record">
            <span>{{ record.renewType === 1 ? '安心存储' : record.renewType === 2 ? '灵活存储' : '--' }}</span>
          </span>
          <span slot="status" slot-scope="text, record">
            <a-badge v-if="record.status === 1" :status="record.status === 1 ? 'success' : 'default'" :text="record.status === 1 ? '有效' : '--'" />
            <span v-else>--</span>
          </span>
        </a-table>
      </div>
    </a-modal>
  </div>
</template>

<script>
import { getStorageInfo, allocateStorage, getStorageRecords } from '@/api/VR/storage'
import { fetchList } from '@/api/VR/tenantStorage/index'

export default {
  name: 'TrafficAllocation',
  data() {
    return {
      searchKeyword: '',
      allocationAmount: '',
      selectedAgentId: '',
      selectedAgentName: '',
      selectedAgents: [], // 存储多个选中的代理商
      tempSelectedAgents: [], // 弹窗中临时选中的代理商
      sharedAgentName: '',
      isSharedMode: false,
      selectedTrafficCard: 'remaining',
      storagePoolId: null,
      agents: [],
      records: [],
      allocationLoading: false,
      recordsLoading: false,
      agentsLoading: false,
      globalLoading: false, // 全局加载动画状态
      loadingTip: '正在分配容量，请稍候...', // 加载提示文字
      allocationProgress: [], // 分配进度列表
      agentModalVisible: false,
      activeTab: '1',
      pageLoading: false,
      isInternalRouteChange: false, // 标记内部路由变化，避免触发重复初始化
      agentQueryParam: {
        pageNum: 1,
        pageSize: 10,
        proxyType: 0,
        name: '',
        contacts: '',
        mobile: '',
        code: '',
      },
      agentColumns: [
        {
          title: '单位名称',
          width: '120px',
          fixed: 'left',
          dataIndex: 'name',
          scopedSlots: { customRender: 'name' },
          align: 'center',
        },
        {
          title: '联系人名称',
          width: '100px',
          dataIndex: 'contacts',
          scopedSlots: { customRender: 'contactInfo' },
          align: 'center',
        },

        {
          title: '容量使用',
          width: '160px',
          dataIndex: 'usedCapacity',
          scopedSlots: { customRender: 'capacityUsage' },
          align: 'center',
        },
        {
          title: '共享容量使用',
          width: '160px',
          dataIndex: 'sumAllocateCapacity',
          scopedSlots: { customRender: 'sharedCapacityUsage' },
          align: 'center',
        },
        {
          title: '有效期',
          width: '200px',
          dataIndex: 'effectiveTime',
          scopedSlots: { customRender: 'effectiveTime' },
          align: 'center',
        },
        {
          title: '存储类型',
          width: '100px',
          dataIndex: 'renewType',
          scopedSlots: { customRender: 'renewType' },
          align: 'center',
        },
        {
          title: '状态',
          width: '80px',
          dataIndex: 'status',
          scopedSlots: { customRender: 'status' },
          align: 'center',
        },
      ],
      agentPagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        showSizeChanger: true,
        showQuickJumper: true,
        showTotal: (total, range) => `共 ${total} 条`,
        pageSizeOptions: ['10', '20', '50'],
        size: 'small',
      },
      recordColumns: [
        {
          title: '分配时间',
          dataIndex: 'createTime',
          key: 'createTime',
          width: '160px',
          align: 'center',
          scopedSlots: { customRender: 'createTime' },
        },
        {
          title: '代理商',
          dataIndex: 'agentTenantName',
          key: 'agentTenantName',
          align: 'center',
          scopedSlots: { customRender: 'agentTenantName' },
        },
        {
          title: '分配容量',
          dataIndex: 'capacity',
          key: 'capacity',
          align: 'center',
          scopedSlots: { customRender: 'capacity' },
        },
        {
          title: '已使用容量',
          dataIndex: 'usedCapacity',
          key: 'usedCapacity',
          align: 'center',
          scopedSlots: { customRender: 'usedCapacity' },
        },
        {
          title: '剩余容量',
          dataIndex: 'remainingCapacity',
          key: 'remainingCapacity',
          align: 'center',
          scopedSlots: { customRender: 'remainingCapacity' },
        },
        {
          title: '过期时间',
          dataIndex: 'expireTime',
          key: 'expireTime',
          align: 'center',
          scopedSlots: { customRender: 'expireTime' },
        },
        {
          title: '状态',
          dataIndex: 'status',
          key: 'status',
          scopedSlots: { customRender: 'status' },
          align: 'center',
        },
      ],
      storageData: {
        totalCapacity: 0,
        totalUsedCapacity: 0,
        remainingCapacity: 0,
        sumAllocateCapacity: 0,
        sumUsedCapacity: 0,
      },
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        showSizeChanger: true,
        showQuickJumper: true,
        showTotal: (total, range) => `共 ${total} 条`,
        pageSizeOptions: ['10', '20', '50'],
        size: 'small',
      },
    }
  },
  computed: {
    usagePercentage() {
      if (!this.storageData || !this.storageData.totalCapacity) return 0
      const percentage = (this.storageData.totalUsedCapacity / this.storageData.totalCapacity) * 100
      return Math.min(Math.round(percentage * 100) / 100, 100)
    },
    canAllocate() {
      return this.getRemainingCapacity() >= 10240
    },
    // 表格行选择配置
    rowSelection() {
      return {
        type: 'checkbox',
        selectedRowKeys: this.tempSelectedAgents.map(agent => agent.tenantId),
        onChange: this.onSelectChange,
        getCheckboxProps: record => {
          const isDisabled = this.isSelectDisabled(record)
          // 当 renewType 等于 1 且 Id 为空时，不仅禁用还隐藏复选框
          return {
            disabled: isDisabled,
            style: isDisabled ? { display: 'none' } : {},
          }
        },
        // 自定义选择框
        renderCell: ({ checked, record, index, onChange }) => {
          // 当 renewType 等于 1 且 Id 为空时，不渲染选择框
          if (this.isSelectDisabled(record)) {
            return null
          }
          // 否则渲染默认的复选框
          return <a-checkbox checked={checked} onChange={e => onChange(e.target.checked)} />
        },
      }
    },
  },
  created() {
    this.initFromRoute()
  },

  watch: {
    '$route.query': {
      handler(newQuery, oldQuery) {
        // 监听路由参数变化，但避免在页面内部操作时重复初始化
        // 只有在关键参数真正发生变化时才重新初始化
        const tenantIdChanged = newQuery.tenantId !== oldQuery?.tenantId
        const storagePoolIdChanged = newQuery.storagePoolId !== oldQuery?.storagePoolId

        if (tenantIdChanged || storagePoolIdChanged) {
          // 防止在页面内部操作（如选择代理商）时触发重复初始化
          if (!this.isInternalRouteChange) {
            this.initFromRoute()
          } else {
            // 重置内部操作标志
            this.isInternalRouteChange = false
          }
        }
      },
      deep: true,
    },
  },
  methods: {
    // 获取总需要的分配容量（多代理商时需要乘以数量）
    getTotalAllocationNeeded() {
      if (!this.allocationAmount) return 0
      const allocationMB = this.getAllocationAmountMB()
      const agentCount = this.selectedAgents.length > 0 ? this.selectedAgents.length : (this.selectedAgentId ? 1 : 0)
      return allocationMB * agentCount
    },

    getUsageRate(record) {
      if (!record.totalCapacity || record.totalCapacity === 0) return 0
      const rate = ((record.usedCapacity || 0) / record.totalCapacity) * 100
      return Math.min(100, Math.max(0, rate.toFixed(1)))
    },

    getProgressColor(record) {
      const rate = this.getUsageRate(record)
      if (rate >= 90) return '#ff4d4f'
      if (rate >= 70) return '#faad14'
      return '#52c41a'
    },

    getSharedUsageRate(record) {
      if (!record.sumAllocateCapacity || record.sumAllocateCapacity === 0) return 0
      const rate = ((record.sumUsedCapacity || 0) / record.sumAllocateCapacity) * 100
      return Math.min(100, Math.max(0, rate.toFixed(1)))
    },

    getSharedProgressColor(record) {
      const rate = this.getSharedUsageRate(record)
      if (rate >= 90) return '#ff4d4f'
      if (rate >= 70) return '#faad14'
      return '#52c41a'
    },

    // 获取容量不足的警告信息
    getInsufficientCapacityWarning() {
      if (!this.allocationAmount) return ''

      const allocationMB = this.getAllocationAmountMB()
      const agentCount = this.selectedAgents.length > 0 ? this.selectedAgents.length : (this.selectedAgentId ? 1 : 0)

      if (agentCount === 0) return ''

      const totalNeeded = allocationMB * agentCount
      const remainingCapacity = this.getRemainingCapacity()

      if (totalNeeded > remainingCapacity) {
        if (this.isSharedMode) {
          return `容量不足，当前最多可分配 ${(remainingCapacity / 1024).toFixed(1)}GB`
        } else {
          return `容量不足，为 ${agentCount} 个代理商各分配 ${this.allocationAmount}GB 共需 ${(totalNeeded / 1024).toFixed(1)}GB`
        }
      }

      return ''
    },

    clearSelectedAgent() {
      this.selectedAgentId = ''
      this.selectedAgentName = ''
      this.selectedAgents = []
      this.tempSelectedAgents = []
      this.sharedAgentName = ''
      this.isSharedMode = false

      // 清除路由中的代理商参数
      const query = {
        ...this.$route.query,
        storagePoolId: this.storagePoolId,
      }
      delete query.tenantId
      delete query.tenantName

      // 标记这是内部路由变化
      this.isInternalRouteChange = true

      this.$router.replace({
        name: 'TrafficAllocation',
        query: query,
      }).catch(err => {
        // 忽略重复路由的错误
        if (err.name !== 'NavigationDuplicated') {
          console.error('路由更新失败:', err)
        }
      })

      if (!this.isSharedMode) {
        this.$message.info('已取消选择代理商')
      }
    },

    // 获取已选代理商的文本显示
    getSelectedAgentsText() {
      if (this.selectedAgents.length === 0) {
        return '请选择代理商'
      }
      return this.selectedAgents.map(agent => agent.name).join(', ')
    },

    // 检查代理商是否已被选中
    isAgentSelected(tenantId) {
      return this.selectedAgents.some(agent => agent.tenantId === tenantId)
    },

    // 切换代理商选择状态
    toggleAgentSelection(agent) {
      const index = this.selectedAgents.findIndex(a => a.tenantId === agent.tenantId)
      if (index > -1) {
        // 如果已选中，则取消选择
        this.selectedAgents.splice(index, 1)
        if (!this.isSharedMode) {
          this.$message.info(`已取消选择代理商: ${agent.name}`)
        }
      } else {
        // 如果未选中，则添加到选中列表
        this.selectedAgents.push({
          tenantId: agent.tenantId,
          name: agent.name,
          id: agent.id,
        })
        if (!this.isSharedMode) {
          this.$message.success(`已选择代理商: ${agent.name}`)
        }
      }

      // 更新兼容字段
      if (this.selectedAgents.length > 0) {
        this.selectedAgentId = this.selectedAgents[0].tenantId
        this.selectedAgentName = this.selectedAgents[0].name
      } else {
        this.selectedAgentId = ''
        this.selectedAgentName = ''
      }
    },

    // 移除选中的代理商
    removeSelectedAgent(index) {
      this.selectedAgents.splice(index, 1)
      if (this.selectedAgents.length > 0) {
        this.selectedAgentId = this.selectedAgents[0].tenantId
        this.selectedAgentName = this.selectedAgents[0].name
      } else {
        this.selectedAgentId = ''
        this.selectedAgentName = ''
      }
    },

    // 清空所有选中的代理商
    clearAllAgents() {
      this.selectedAgents = []
      this.tempSelectedAgents = []
      this.selectedAgentId = ''
      this.selectedAgentName = ''
      if (!this.isSharedMode) {
        this.$message.info('已清空所有选中的代理商')
      }
    },

    getRemainingCapacity() {
      return this.storageData?.remainingCapacity || 0
    },

    getAgents() {
      this.agentsLoading = true

      const params = {
        pageNum: this.agentQueryParam.pageNum,
        pageSize: this.agentQueryParam.pageSize,
        proxyType: this.agentQueryParam.proxyType,
      }

      if (this.agentQueryParam.name) params.tenantName = this.agentQueryParam.name
      if (this.agentQueryParam.contacts) params.userName = this.agentQueryParam.contacts
      if (this.agentQueryParam.mobile) params.userPhone = this.agentQueryParam.mobile
      if (this.agentQueryParam.code) params.code = this.agentQueryParam.code

      fetchList(params)
        .then((response) => {
          if (response.success && response.data) {
            this.agents = this.cleanDataList(response.data.records || [])
            this.agentPagination.total = response.data.total || 0
            this.agentPagination.current = response.data.current || this.agentQueryParam.pageNum // 确保分页组件显示正确的当前页码

            // 数据加载完成后，强制表格重新计算布局
            this.$nextTick(() => {
              setTimeout(() => {
                if (this.$refs.agentTable) {
                  // 尝试调用 handleResize 方法
                  if (this.$refs.agentTable.handleResize) {
                    this.$refs.agentTable.handleResize()
                  } else {
                    // 备选方案：通过改变窗口大小触发布局重计算
                    window.dispatchEvent(new Event('resize'))
                  }
                }
              }, 100)
            })
          } else {
            this.agents = []
            this.agentPagination.total = 0
          }
          this.agentsLoading = false
        })
        .catch(() => {
          this.agentsLoading = false
          this.agents = []
          this.agentPagination.total = 0
        })
    },

    cleanDataList(list) {
      return list.map((item) => {
        const cleaned = { ...item }
        const fields = ['name', 'contacts', 'mobile', 'effectiveTime', 'expireTime']
        fields.forEach((field) => {
          if (cleaned[field] === null) {
            cleaned[field] = '--'
          }
        })
        return cleaned
      })
    },

    showAgentModal() {
      this.agentModalVisible = true
      // 初始化临时选中列表为当前已选中的代理商
      this.tempSelectedAgents = [...this.selectedAgents]
      this.resetAgentQuery()
      this.getAgents()

      // 在模态框显示后，延迟执行表格布局重新计算
      this.$nextTick(() => {
        setTimeout(() => {
          if (this.$refs.agentTable) {
            // 尝试调用 handleResize 方法
            if (this.$refs.agentTable.handleResize) {
              this.$refs.agentTable.handleResize()
            } else {
              // 备选方案：通过改变窗口大小触发布局重计算
              window.dispatchEvent(new Event('resize'))
            }
          }
        }, 300) // 增加延迟时间确保模态框完全渲染
      })
    },

    closeAgentModal() {
      this.agentModalVisible = false
      // 关闭弹窗时清空临时选中列表
      this.tempSelectedAgents = []
    },

    // 确认代理商选择
    confirmAgentSelection() {
      if (this.tempSelectedAgents.length === 0) {
        this.$message.warning('请至少选择一个代理商')
        return
      }

      // 将临时选中的代理商更新到正式选中列表
      this.selectedAgents = [...this.tempSelectedAgents]

      // 更新兼容字段
      if (this.selectedAgents.length > 0) {
        this.selectedAgentId = this.selectedAgents[0].tenantId
        this.selectedAgentName = this.selectedAgents[0].name
      } else {
        this.selectedAgentId = ''
        this.selectedAgentName = ''
      }

      this.agentModalVisible = false
      this.tempSelectedAgents = []
    },

    // 表格行选择变化
    onSelectChange(selectedRowKeys, selectedRows) {
      // 过滤掉不应该被选中的记录（当 renewType 等于 1 且 Id 为空时）
      const filteredRows = selectedRows.filter(row => !this.isSelectDisabled(row))

      // 更新临时选中的代理商列表
      this.tempSelectedAgents = filteredRows.map(row => ({
        tenantId: row.tenantId,
        name: row.name,
        id: row.id,
      }))

      // 如果有被过滤掉的记录，更新 selectedRowKeys
      if (filteredRows.length !== selectedRows.length) {
        // 获取表格组件实例
        const table = this.$refs.agentTable
        if (table) {
          // 更新表格的选中状态
          table.selectedRowKeys = filteredRows.map(row => row.tenantId)
        }
      }
    },

    // 检查临时代理商是否已被选中
    isTempAgentSelected(tenantId) {
      return this.tempSelectedAgents.some(agent => agent.tenantId === tenantId)
    },

    // 切换临时代理商选择状态
    toggleTempAgentSelection(checked, record) {
      if (checked) {
        // 添加到临时选中列表
        if (!this.isTempAgentSelected(record.tenantId)) {
          this.tempSelectedAgents.push({
            tenantId: record.tenantId,
            name: record.name,
            id: record.id,
          })
        }
      } else {
        // 从临时选中列表中移除
        const index = this.tempSelectedAgents.findIndex(agent => agent.tenantId === record.tenantId)
        if (index > -1) {
          this.tempSelectedAgents.splice(index, 1)
        }
      }
    },

    handleTabChange(activeKey) {
      this.agentQueryParam.proxyType = parseInt(activeKey) - 1
      this.agentQueryParam.pageNum = 1
      this.getAgents()
    },

    handleAgentQuery() {
      this.agentQueryParam.pageNum = 1
      this.getAgents()
    },

    resetAgentQuery() {
      this.agentQueryParam = {
        pageNum: 1,
        pageSize: 10,
        proxyType: parseInt(this.activeTab) - 1,
        name: '',
        contacts: '',
        mobile: '',
        code: '',
      }
      this.getAgents()
    },

    handleAgentTableChange(pagination, filters, sorter) {
      this.agentQueryParam.pageNum = pagination.current
      this.agentQueryParam.pageSize = pagination.pageSize
      this.agentPagination.current = pagination.current // 同步更新分页组件的当前页码
      this.getAgents()
    },

    selectAgentAndClose(agent) {
      // 验证代理商数据的有效性
      if (!agent) {
        this.$message.error('代理商数据无效，请重新选择')
        return
      }

      // 当 renewType 等于 1 时，检查 Id 是否为空
      if (this.storageData.renewType === 1 && (!agent.id || agent.id === '')) {
        this.$message.warning('该代理商信息不完整，无法选择')
        return
      }

      // 添加到选中列表
      if (!this.isAgentSelected(agent.tenantId)) {
        this.selectedAgents.push({
          tenantId: agent.tenantId,
          name: agent.name,
          id: agent.id,
        })

        // 更新兼容字段
        this.selectedAgentId = this.selectedAgents[0].tenantId
        this.selectedAgentName = this.selectedAgents[0].name
      }

      this.closeAgentModal()
      if (!this.isSharedMode) {
        this.$message.success(`已选择代理商: ${agent.name}`)
      }

      // 更新路由参数，确保刷新页面时能保持选择状态
      this.updateRouteWithSelectedAgent(agent)
    },

    updateRouteWithSelectedAgent(agent) {
      // 标记这是内部路由变化，避免触发watch中的重新初始化
      this.isInternalRouteChange = true

      const query = {
        ...this.$route.query,
        tenantId: agent.id,
        tenantName: agent.name,
        storagePoolId: this.storagePoolId,
      }

      // 替换当前路由，避免产生历史记录
      this.$router.replace({
        name: 'TrafficAllocation',
        query: query,
      }).catch(err => {
        // 忽略重复路由的错误
        if (err.name !== 'NavigationDuplicated') {
          console.error('路由更新失败:', err)
        }
      })
    },

    async getDefaultStoragePoolId() {
      try {
        const response = await getStorageInfo()

        if (response && Array.isArray(response.data)) {
          const defaultStorage = response.data.find(
            (item) => item.tenantName && item.tenantName.includes('本单位存储')
          )

          if (defaultStorage && defaultStorage.id) {
            return defaultStorage.id
          } else {
            console.warn('未找到本单位存储池')
            return null
          }
        } else {
          console.warn('获取存储池信息返回数据格式异常')
          return null
        }
      } catch (error) {
        console.error('获取默认存储池ID失败:', error)
        return null
      }
    },

    async initFromRoute() {
      this.pageLoading = true
      try {
        const { tenantId, tenantName } = this.$route.query
        let { storagePoolId } = this.$route.query

        // 重置状态，避免页面间跳转时的状态残留
        this.resetPageState()

        if (!storagePoolId) {
          storagePoolId = await this.getDefaultStoragePoolId()

          if (!storagePoolId) {
            this.$message.error('缺少存储池信息且无法获取默认存储池')
            this.$router.go(-1)
            return
          }
        }

        this.storagePoolId = storagePoolId

        if (tenantId) {
          // 从租户存储列表页面跳转过来，有指定的代理商
          this.isSharedMode = true
          this.selectedAgentId = tenantId
          this.sharedAgentName = tenantName || `租户${tenantId}`
          this.selectedAgentName = this.sharedAgentName
        } else {
          // 从存储套餐页面跳转过来，需要手动选择代理商
          this.isSharedMode = false
          this.selectedAgentId = ''
          this.selectedAgentName = ''
          this.sharedAgentName = ''
        }

        await this.fetchStorageData(this.storagePoolId)
        this.fetchRecords()
      } catch (error) {
        this.$message.error('页面初始化失败')
      } finally {
        this.pageLoading = false
      }
    },

    resetPageState() {
      // 重置所有页面状态，避免页面间跳转时的状态残留
      this.selectedAgentId = ''
      this.selectedAgentName = ''
      this.selectedAgents = []
      this.tempSelectedAgents = []
      this.sharedAgentName = ''
      this.isSharedMode = false
      this.allocationAmount = ''
      this.agents = []
      this.records = []
      this.agentModalVisible = false
      this.activeTab = '1'
    },

    async fetchStorageData(storagePoolId) {
      try {
        const response = await getStorageInfo()

        if (response && Array.isArray(response.data) && response.data.length > 0) {
          const storage = response.data.find(item => item.id === storagePoolId) || response.data[0]
          this.storageData = storage

          this.storageData.remainingCapacity = this.storageData.totalCapacity - this.storageData.totalUsedCapacity
        } else {
          console.warn('获取存储数据为空或格式不正确')
          this.storageData = {
            totalCapacity: 0,
            totalUsedCapacity: 0,
            remainingCapacity: 0,
            sumAllocateCapacity: 0,
            sumUsedCapacity: 0,
          }
        }
      } catch (error) {
        console.error('获取存储套餐信息失败:', error)
        this.storageData = {
          totalCapacity: 0,
          totalUsedCapacity: 0,
          remainingCapacity: 0,
          sumAllocateCapacity: 0,
          sumUsedCapacity: 0,
        }
      }
    },

    async fetchRecords() {
      try {
        this.recordsLoading = true
        const params = {
          pageNum: this.pagination.current,
          pageSize: this.pagination.pageSize,
          enterpriseOwnPoolId: this.storagePoolId,
        }

        const response = await getStorageRecords(params)

        if (response && response.success) {
          this.records = response.data.records || []
          this.pagination.total = response.data.total || 0
          this.pagination.current = response.data.current || this.pagination.current // 确保分页组件显示正确的当前页码
        } else {
          this.records = []
          this.pagination.total = 0
        }
      } catch (error) {
        console.error('获取分配记录失败:', error)
        this.records = []
        this.pagination.total = 0
      } finally {
        this.recordsLoading = false
      }
    },

    handleTableChange(pagination, filters, sorter) {
      this.pagination.current = pagination.current
      this.pagination.pageSize = pagination.pageSize
      this.fetchRecords()
    },

    formatDate(dateString) {
      if (!dateString) return '-'
      try {
        const date = new Date(dateString)
        return date.toLocaleString()
      } catch (error) {
        console.error('日期格式化错误:', error)
        return '-'
      }
    },

    getAllocationAmountMB() {
      if (!this.allocationAmount) return 0
      const amount = parseFloat(this.allocationAmount)
      return isNaN(amount) ? 0 : amount * 1024
    },

    getMaxAllocation() {
      const maxMB = this.getRemainingCapacity()
      return maxMB / 1024
    },

    getMinAllocation() {
      return 10
    },

    selectTrafficCard(cardType) {
      this.selectedTrafficCard = cardType
    },

    async confirmAllocation() {
      const allocationMB = this.getAllocationAmountMB()

      if (!this.isSharedMode && this.selectedAgents.length === 0 && !this.selectedAgentId) {
        this.$message.warning('请先选择代理商')
        return
      }

      if (!this.canAllocate) {
        this.$message.warning('剩余可分配容量不足10GB，无法进行分配')
        return
      }

      if (!allocationMB || allocationMB < 10240) {
        this.$message.warning('分配容量不能小于10GB')
        return
      }

      if (allocationMB > this.getRemainingCapacity()) {
        this.$message.warning('分配容量不能超过剩余可分配容量')
        return
      }

      // 开启全局加载动画
      this.globalLoading = true
      this.allocationLoading = true

      try {
        // 如果有多个选中的代理商，为每个代理商分配相同的容量
        const agentsToAllocate = this.selectedAgents.length > 0 ? this.selectedAgents : [{
          tenantId: this.selectedAgentId,
          name: this.selectedAgentName,
        }]

        let successCount = 0
        let failCount = 0

        // 初始化分配进度列表
        this.allocationProgress = []

        // 为每个代理商单独调用分配接口
        for (let i = 0; i < agentsToAllocate.length; i++) {
          const agent = agentsToAllocate[i]
          const agentNumber = i + 1 // 第几个代理商

          try {
            const params = {
              agentTenantId: agent.tenantId,
              allocateCapacity: allocationMB,
              enterpriseOwnPoolId: this.storagePoolId,
            }

            const response = await allocateStorage(params)

            if (response.success) {
              successCount++
              // 将成功信息添加到进度列表中
              const progressMessage = this.isSharedMode
                ? `分配成功 ${this.allocationAmount}GB`
                : `第${agentNumber}个代理商：${agent.name} 分配成功 ${this.allocationAmount}GB`

              this.allocationProgress.push({
                success: true,
                message: progressMessage,
              })

              // 更新加载提示文字
              this.loadingTip = this.isSharedMode
                ? `正在分配容量... (${successCount}/${agentsToAllocate.length})`
                : `正在为代理商分配容量... (${successCount}/${agentsToAllocate.length})`
            } else {
              failCount++
              console.error(`分配给代理商 ${agent.name} 失败:`, response.message)

              // 将失败信息添加到进度列表中
              const errorMessage = this.isSharedMode
                ? `分配失败: ${response.message || '未知错误'}`
                : `第${agentNumber}个代理商：${agent.name} 分配失败: ${response.message || '未知错误'}`

              this.allocationProgress.push({
                success: false,
                message: errorMessage,
              })

              // 共享模式下显示错误消息，普通模式下在加载框中显示
              if (this.isSharedMode) {
                this.$message.error(`分配失败: ${response.message || '未知错误'}`)
              }
            }
          } catch (error) {
            failCount++
            console.error(`分配给代理商 ${agent.name} 失败:`, error)

            // 将失败信息添加到进度列表中
            const errorMessage = this.isSharedMode
              ? `分配失败: ${error.message || '网络错误'}`
              : `第${agentNumber}个代理商：${agent.name} 分配失败: ${error.message || '网络错误'}`

            this.allocationProgress.push({
              success: false,
              message: errorMessage,
            })

            // 共享模式下显示错误消息，普通模式下在加载框中显示
            if (this.isSharedMode) {
              this.$message.error(`分配失败: ${error.message || '网络错误'}`)
            }
          }
        }

        // 所有分配完成后，显示汇总信息
        if (successCount > 0) {
          const totalAllocated = this.allocationAmount * successCount

          if (this.isSharedMode) {
            // 共享模式下只显示一个简洁的成功消息
            this.$message.success(`容量分配成功 ${totalAllocated} GB`)
          } else {
            // 普通模式下显示详细的分配结果
            if (failCount === 0) {
              this.$message.success(`所有代理商分配完成，共分配 ${totalAllocated} GB 容量`)
            } else {
              this.$message.warning(`分配完成：成功 ${successCount} 个，失败 ${failCount} 个，共分配 ${totalAllocated} GB 容量`)
            }
          }

          this.allocationAmount = ''
          await this.fetchStorageData(this.storagePoolId)
          this.fetchRecords()
        } else {
          // 全部失败的情况
          if (this.isSharedMode) {
            this.$message.error('容量分配失败，请稍后重试')
          } else {
            this.$message.error('所有代理商分配失败，请稍后重试')
          }
        }
      } catch (error) {
        console.error('分配存储失败:', error)
        this.$message.error('分配过程中发生异常，请稍后重试')
      } finally {
        // 关闭全局加载动画
        this.globalLoading = false
        this.allocationLoading = false
        // 清空进度列表和重置加载提示
        this.allocationProgress = []
        this.loadingTip = '正在分配容量，请稍候...'
      }
    },

    cancelAllocation() {
      this.allocationAmount = ''
    },

    getStatusText(status) {
      const statusMap = {
        1: '有效',
        2: '已过期',
        3: '已用完',
        4: '已回收',
      }
      return statusMap[status] || '未知'
    },

    getStatusClass(status) {
      const statusClassMap = {
        1: 'status-processing',
        2: 'status-cancelled',
        3: 'status-completed',
        4: 'status-cancelled',
      }
      return `status-tag ${statusClassMap[status] || 'status-default'}`
    },

    isSelectDisabled(record) {
      // 当 renewType 等于 1 时，如果 Id 为空则禁用选择
      const shouldDisable = this.storageData.renewType === 1 && (!record.id || record.id === '')
      // 调试日志
      console.log('isSelectDisabled 调试信息:', {
        renewType: this.storageData.renewType,
        recordId: record.id,
        recordName: record.name,
        shouldDisable,
      })
      return shouldDisable
    },

    getRowClassName(record) {
      // 当 renewType 等于 1 且 Id 为空时，给行添加置灰样式
      if (this.storageData.renewType === 1 && (!record.id || record.id === '')) {
        return 'disabled-row'
      }
      return ''
    },
  },
}
</script>

<style scoped>
.container {
  margin: 0 auto;
  background-color: #f0f2f5;
  position: relative;
}

/* 全局加载动画样式 */
.global-loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(255, 255, 255, 0.8);
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
}

.loading-content {
  width: 300px;
  min-height: 100px;
  max-height: 400px;
  overflow-y: auto;
}

.allocation-progress-list {
  margin-top: 16px;
  max-height: 300px;
  overflow-y: auto;
}

.progress-item {
  display: flex;
  align-items: center;
  padding: 8px 12px;
  margin-bottom: 8px;
  background-color: #f9f9f9;
  border: 1px solid #e8e8e8;
  border-radius: 4px;
  font-size: 12px;
  line-height: 1.4;
}

.progress-item:last-child {
  margin-bottom: 0;
}

.progress-item.success {
  background-color: #f6ffed;
  border-color: #b7eb8f;
  color: #52c41a;
}

.progress-item.error {
  background-color: #fff2f0;
  border-color: #ffccc7;
  color: #ff4d4f;
}

.card {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  margin-bottom: 20px;
  padding: 20px;
}

.card-header {
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 20px;
  color: #333;
}

.agent-search-section {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}

.agent-search-input {
  margin-right: 10px;
  flex: 1;
}

.selected-agent-info {
  margin-top: 10px;
}

.selected-agents-container {
  margin-top: 10px;
}

.selected-agents-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;
  margin-bottom: 10px;
}

.selected-agent-simple {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px;
  background: #f5f5f5;
  border-radius: 4px;
  border: 1px solid #d9d9d9;
  min-height: 60px;
}

.selected-agent-simple.selected-agent {
  background-color: #e6f7ff;
  border-color: #91d5ff;
}

.clear-all-section {
  text-align: right;
  margin-top: 8px;
}

.clear-all-btn {
  color: #ff4d4f;
  font-size: 12px;
}

.clear-all-btn:hover {
  color: #ff7875;
}

.selected-agent-text {
  display: flex;
  flex-direction: column;
}

.agent-name {
  font-weight: 500;
  color: #333;
  margin-bottom: 4px;
}

.agent-id {
  font-size: 12px;
  color: #666;
}

.clear-btn {
  color: #999;
  padding: 0;
  height: auto;
}

.clear-btn:hover {
  color: #ff4d4f;
}

.traffic-info {
  display: flex;
  gap: 12px;
  margin-bottom: 15px;
}

.traffic-card {
  flex: 1;
  padding: 16px;
  background-color: #f9fafb;
  border-radius: 4px;
  border: 1px solid #e8e8e8;
}

.traffic-card-remaining {
  background-color: #f6ffed;
  border-color: #b7eb8f;
}

.traffic-label {
  color: #666;
  font-size: 14px;
  margin-bottom: 8px;
}

.traffic-value {
  font-size: 18px;
  font-weight: 500;
  color: #333;
}

.progress-info {
  display: flex;
  justify-content: space-between;
  margin-top: 16px;
  font-size: 12px;
  color: #8c8c8c;
}

.traffic-allocation {
  margin-top: 20px;
}

.allocation-input-section {
  display: flex;
  align-items: center;
  margin-top: 10px;
}

.allocation-input {
  width: 200px;
  margin-right: 10px;
}

.allocation-unit {
  margin: 0 10px;
  color: #666;
}

.max-allocation {
  font-size: 12px;
  color: #8c8c8c;
  margin-top: 10px;
}

.allocation-warning {
  margin-top: 10px;
  padding: 8px 12px;
  background-color: #fffbe6;
  border: 1px solid #ffe58f;
  border-radius: 4px;
  color: #d48806;
  font-size: 12px;
  display: flex;
  align-items: center;
}

.allocation-error {
  margin-top: 10px;
  padding: 8px 12px;
  background-color: #fff2f0;
  border: 1px solid #ffccc7;
  border-radius: 4px;
  color: #ff4d4f;
  font-size: 12px;
  display: flex;
  align-items: center;
}

.status-tag {
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  display: inline-block;
}

.status-completed {
  background-color: #f6ffed;
  color: #52c41a;
  border: 1px solid #b7eb8f;
}

.status-processing {
  background-color: #e6f7ff;
  color: #1890ff;
  border: 1px solid #91d5ff;
}

.status-cancelled {
  background-color: #fff2f0;
  color: #ff4d4f;
  border: 1px solid #ffccc7;
}

.status-default {
  background-color: #fafafa;
  color: #8c8c8c;
  border: 1px solid #d9d9d9;
}

.modal-content {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.table-page-search-wrapper {
  margin-bottom: 16px;
}

.table-page-search-submitButtons {
  float: right;
  overflow: hidden;
}

.tenant-name {
  display: inline-block;
  max-width: 100px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  vertical-align: middle;
}

.shared-agent-info {
  padding: 16px;
  background-color: #f6ffed;
  border: 1px solid #b7eb8f;
  border-radius: 4px;
}

.shared-agent-detail {
  line-height: 1.6;
}

.shared-agent-name {
  font-size: 16px;
  font-weight: bold;
  color: #333;
  margin-bottom: 4px;
}

.shared-agent-id {
  font-size: 14px;
  color: #666;
}

.text-ellipsis {
  display: inline-block;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  vertical-align: middle;
}

.capacity-container {
  width: 100%;
}

.capacity-progress {
  width: 100%;
  height: 8px;
  background-color: #f0f0f0;
  border-radius: 4px;
  overflow: hidden;
  margin-bottom: 4px;
}

.progress-bar {
  height: 100%;
  border-radius: 4px;
  transition: all 0.3s ease;
}

.capacity-text {
  font-size: 12px;
  font-weight: 500;
  text-align: center;
}

.ant-table-thead > tr > th,
.ant-table-tbody > tr > td {
  text-align: center;
  vertical-align: middle;
}

.ant-table-wrapper {
  overflow-x: auto;
}

.ant-table-tbody > tr > td {
  padding: 8px;
}

.ant-table-thead > tr > th {
  padding: 12px 8px;
  font-weight: 600;
}

.ant-tabs {
  margin-bottom: 16px;
}

.ant-tabs-bar {
  margin-bottom: 16px;
}

::v-deep .disabled-row {
  background-color: #f5f5f5 !important;
  opacity: 0.6;
  pointer-events: none;
}

::v-deep .disabled-row td {
  color: #999 !important;
}

::v-deep .disabled-row .ant-btn-link {
  color: #ccc !important;
  cursor: not-allowed !important;
}

::v-deep .disabled-row .ant-btn-link:hover {
  color: #ccc !important;
}
</style>
